import { get } from '@apis/api';
import { CommonResponse } from '@models/api';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};

export interface SmartBannerData {
  buttonText: string;
  loginTitle: string;
  loginSubTitle: string;
  nonLoginTitle: string;
  nonLoginSubTitle: string;
}
export function getSmartBannerApi() {
  return `/display/api/smart-banner/v1/banner`;
}

export const requestSmartBannerData = async () => {
  const { data } = await get<CommonResponse<SmartBannerData>>({
    url: getSmartBannerApi(),
    baseUrl: baseURL,
    options,
  });
  return data;
};
